import { render, staticRenderFns } from "./ContentManagement.vue?vue&type=template&id=43922ba0"
import script from "./ContentManagement.vue?vue&type=script&lang=js"
export * from "./ContentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports